import ButtonIcon from "components/ButtonIcon/ButtonIcon";
import { useEffect, useState } from "react";

import { useLienDirectorySearch } from "../hooks/useLienDirectorySearch";

const LienDirectorySearchBar = () => {
  const { lienDirectorySearchTerm, debouncedSetSearchTerm } =
    useLienDirectorySearch();
  const [inputValue, setInputValue] = useState(lienDirectorySearchTerm || "");

  useEffect(() => {
    setInputValue(lienDirectorySearchTerm || "");
  }, [lienDirectorySearchTerm]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    debouncedSetSearchTerm(newValue);
  };

  const handleClearSearch = () => {
    setInputValue("");
    debouncedSetSearchTerm("");
  };

  return (
    <div className="SearchBar">
      <div className="SearchBar__SearchBar__Search">
        <ButtonIcon onClick={() => {}}>search</ButtonIcon>
        <input
          className="SearchBar__SearchBar__Search__SearchInput"
          value={inputValue}
          onChange={handleSearchChange}
          placeholder="Search directory entries..."
        />
        <div className="SearchBar__SearchBar__Search__Filters">
          {/* display filters div to maintain spacing */}
        </div>
        <ButtonIcon onClick={handleClearSearch}>close</ButtonIcon>
        <ButtonIcon className="filter_button_icon" disabled onClick={() => {}}>
          filter_list
        </ButtonIcon>
      </div>
    </div>
  );
};

export default LienDirectorySearchBar;
